import { Component, inject, OnInit } from '@angular/core';

// interfaces
import { PageComponent } from '@sideline/sideline-apps-shared';

// services
import { PageService } from '@sideline/sideline-apps-shared';

// components
import { LandingContent } from '../../components/landing-content/landing-content';
import { PublicLayout } from 'app/layouts/public/layout/public.layout';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.html',
  styleUrl: './landing-page.scss',
  standalone: true,
  imports: [
    LandingContent,
    PublicLayout,
  ]
})
export class LandingPage implements PageComponent, OnInit {

  // component
  title: string = '';

  // services
  pageService = inject(PageService);

  // ==========================================================================================================================
  //  hooks
  // ==========================================================================================================================

  ngOnInit(): void {
    this.pageService.setTitle(this.title);
  }

}
